import request from '@/utils/request'
import { downloadBlob } from '../../utils/helpers'
import uuid from 'uniq-id'

export default {
    getReferralCodes: async({ dispatch, commit }, params) => {
        commit('SET_LOAD', true)
        await request({
            method: 'get',
            url: '/referral-code',
            responseType: params.excel ? 'blob' : 'json',
            params: {
                ...Object.select(params, ['page', 'excel', 'column', 'direction'])
            }
        }).then(res => {
            if (res.data && res.data.referralCodes) {
                commit('SET_PAGINATION', {
                    length: res.data.totalPages,
                    page: res.data.page,
                    total: res.data.total,
                    limit: res.data.limit
                })

                commit('SET_REFERRAL_CODES', res.data.referralCodes)
            } else if (res.data && params.excel) {
                downloadBlob(res.data, `Report_${uuid()}.xlsx`)
            }

            commit('SET_LOAD', false)
        })
    },

    addReferralCode: async({ dispatch, commit }, name) => {
        await request({
            method: 'post',
            url: '/referral-code',
            data: {
                name
            }
        })
    },

    removeReferralCode: async({ state, dispatch, commit }, referralCodeId) => {
        await request({
            method: 'delete',
            url: `/referral-code/${referralCodeId}`
        })
    },

    editReferralCode: async({ dispatch, commit }, referralCode) => {
        await request({
            method: 'put',
            url: `/referral-code/${referralCode.id}`,
            data: { name: referralCode.name }
        })
            .then(res => {
                if (res.data && res.data.referralCode) {
                    commit('EDIT_REFERRAL_CODE', res.data.referralCode)
                }
            })
    }
}
